<template>
  <div class="bindRole" style="height: 100%">
    <div class="return">
      <i class="el-icon-back" @click="goReturn">{{$t('LanguageLib.Return')}}</i>
      <span class="border"></span>
      <span class="title">{{$t('LanguageLib.LABEL')}}“{{ titleType }}”{{$t('LanguageLib.ABOUT_PERSON')}}</span>
    </div>
    <div class="content">
      <div class="operation">
        <div class="operationBtn">
          <el-button @click="delPerson()" :disabled="delDisabled">{{$t('LanguageLib.DELETE')}}</el-button>
          <el-button type="primary" @click="addPerson">{{$t('LanguageLib.ADD_TO')}}</el-button>
          <el-button type="primary" icon="el-icon-s-custom" @click="checkedPerson">{{$t('LanguageLib.CHECKED')}}{{selectPersonData.length}}</el-button>
        </div>
        <div class="operationSearch">
          <i @click="drawerOpen" style="cursor: pointer;" class="iconfont shaixuan" :class="{'shaixuan1' : shaixuan1}">&#xe624;</i>
          <span v-show="isSearch" style="color:#666;font-size:14px;">{{$t('LanguageLib.SearchedOut')}}<span class="colorG">{{ pageTotalPerson }} &nbsp;</span>{{$t('LanguageLib.Results')}}</span>
          <i v-show="isSearch" @click="clearSearchData" class="el-icon-close" style="margin:0 10px 0 10px;color:#666;font-size:14px;cursor: pointer;"></i>
          <el-input
            placeholder=""
            prefix-icon="el-icon-search"
            v-model="personListsearchText"
            @keyup.enter.native="searchPersonList"
          >
          </el-input>
        </div>
      </div>
      <div class="domainWarp">
        <DomainTree @isCollapse-treedata="isCollapseTreedataPersonList" @addcheck-treedata="getTreeCheckDataPersonList" :checkDomainId="parentId" :orgData="orgData" :orgTreeData="orgTreeData" :oneNodeArr="oneNodeArr"></DomainTree>
        <div class="tableWarp" :style="styleRightPersonList">
          <div class="tableParent">
            <el-table
              empty-text=" "
              :data="tableDataPerson"
              stripe
              @selection-change="selectionChange"
              @sort-change='sortChangePersonList'
              ref="listPowerSupplyTab"
              style="width: auto;"
              v-loading="loading"
              height="100%">
              <el-table-column
                type="selection"
                width="45">
              </el-table-column>
              <el-table-column
                prop="userName"
                :label="$t('LanguageLib.NAME')"
                sortable="custom"
                min-width="100">
                <template slot-scope="scope">
                  <el-tooltip effect="light" placement="top-start" >
                    <span v-if="!$commonfun.iswx(scope.row.userName) || !JSON.parse($commonfun.localStorage.getitem('qyuser'))" slot="content" type="userName">{{scope.row.userName}}</span>
                    <span v-if="!$commonfun.iswx(scope.row.userName) || !JSON.parse($commonfun.localStorage.getitem('qyuser'))"  style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="userName">{{scope.row.userName}}</span>
                    <span v-if="$commonfun.iswx(scope.row.userName) && JSON.parse($commonfun.localStorage.getitem('qyuser'))" slot="content" type="userName">
                      <ww-open-data slot="content" type="userName" :openid="scope.row.userName.slice(3)"></ww-open-data>
                    </span>
                    <span v-if="$commonfun.iswx(scope.row.userName) && JSON.parse($commonfun.localStorage.getitem('qyuser'))" ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="userName">
                      <ww-open-data slot="content" type="userName" :openid="scope.row.userName.slice(3)"></ww-open-data>
                    </span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                prop="userAccount"
                :label="$t('LanguageLib.ACCOUNT')"
                sortable="custom"
                min-width="100">
                <template slot-scope="scope">
                  <el-tooltip effect="light" placement="top-start">
                    <span slot="content" type="userAccount">{{scope.row.userAccount}}</span>
                    <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="userAccount">{{scope.row.userAccount}}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                prop="postionName"
                :label="$t('LanguageLib.POSITION')"
                sortable="custom"
                min-width="200">
                <template slot-scope="scope">
                <el-tooltip effect="light" placement="top-start">
                  <!-- 如果有显示职位显示显示职位 -->
                  <span v-if="scope.row.postionName" slot="content" type="postionName">{{scope.row.postionName}}</span>
                  <span v-if="scope.row.postionName" ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="postionName">{{scope.row.postionName}}</span>
                  <!-- 如果没有显示职位显示组织加角色 -->
                  <span v-if="!scope.row.postionName" slot="content" type="postionName"><span v-html="$commonfun.RenderWxName('departmentName', scope.row.defaultDomainName)"></span>&nbsp;{{scope.row.defaultRoleName}}</span>
                  <span v-if="!scope.row.postionName" ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="postionName"><span v-html="$commonfun.RenderWxName('departmentName', scope.row.defaultDomainName)"></span>&nbsp;{{scope.row.defaultRoleName}}</span>
                </el-tooltip>
              </template>
              </el-table-column>
              <el-table-column
                prop="workEmail"
                :label="$t('LanguageLib.MAILBOX')"
                sortable="custom"
                min-width="100">
                <template slot-scope="scope">
                <el-tooltip effect="light" placement="top-start">
                  <span slot="content" type="workEmail">{{scope.row.workEmail}}</span>
                  <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;  vertical-align: middle;" type="workEmail">{{scope.row.workEmail}}</span>
                </el-tooltip>
              </template>
              </el-table-column>
              <el-table-column
                prop="defaultDomainName"
                :label="$t('LanguageLib.ORGANIZATION2')"
                sortable="custom"
                min-width="250">
                <template slot-scope="scope">
                <el-tooltip effect="light" placement="top-start">
                  <ww-open-data slot="content" v-if="$commonfun.iswx(scope.row.defaultDomainName) && JSON.parse($commonfun.localStorage.getitem('qyuser'))" type="departmentName" :openid="scope.row.defaultDomainName.slice(3)"></ww-open-data>
                  <ww-open-data ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" v-if="$commonfun.iswx(scope.row.defaultDomainName) && JSON.parse($commonfun.localStorage.getitem('qyuser'))" type="departmentName" :openid="scope.row.defaultDomainName.slice(3)"></ww-open-data>
                  <span slot="content" type="departmentName" v-if="!$commonfun.iswx(scope.row.defaultDomainName) || !JSON.parse($commonfun.localStorage.getitem('qyuser'))">{{scope.row.defaultDomainName}}</span>
                  <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;  vertical-align: middle;" type="departmentName" v-if="!$commonfun.iswx(scope.row.defaultDomainName) || !JSON.parse($commonfun.localStorage.getitem('qyuser'))">{{scope.row.defaultDomainName}}</span>
                </el-tooltip>
              </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination
            @size-change="handleSizeChangePersonList"
            @current-change="handleCurrentChangePersonList"
            :current-page="personListcurrentPage"
            :page-sizes="[20, 50, 100]"
            :page-size="personListpageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotalPerson">
          </el-pagination>
        </div>
      </div>
      <el-drawer
        :visible.sync="drawer"
        :show-close="true"
        :modal="false"
        :wrapperClosable="false"
        size="420px"
        :with-header="false">
        <div style="overflow: hidden">
          <p style="float: left;" class="drawerTitle">{{$t('LanguageLib.Filter')}}</p>
          <el-button @click="drawerClose" style="float: right;padding: 4px 0 0 0;font-size: 18px;color: #4d4d4d;" type="text"><i class="el-icon-close"></i></el-button>
        </div>
        <div class="filterContentAboutPerson" style="padding-right: 10px;">
          <p class="drawerText">{{$t('LanguageLib.NAME')}}</p>
          <el-input
            :placeholder="$t('LanguageLib.PleaseEnter')"
            v-model="personListUserName"
          >
          </el-input>
          <p class="drawerText">{{$t('LanguageLib.ACCOUNT')}}</p>
          <el-input
            :placeholder="$t('LanguageLib.PleaseEnter')"
            v-model="personListUserAccount"
          >
          </el-input>
          <p class="drawerText">{{$t('LanguageLib.POSITION')}}</p>
          <el-input
            :placeholder="$t('LanguageLib.PleaseEnter')"
            v-model="personListPostionName"
          >
          </el-input>
          <p class="drawerText">{{$t('LanguageLib.MAILBOX')}}</p>
          <el-input
            :placeholder="$t('LanguageLib.PleaseEnter')"
            v-model="personListEmail"
          >
          </el-input>
          <p class="drawerText">{{$t('LanguageLib.ORGANIZATION2')}}</p>
          <el-input
            :placeholder="$t('LanguageLib.PleaseEnter')"
            v-model="personListDomainName"
          >
          </el-input>
        </div>
        <div style="float: right;margin-top: 10px;">
          <el-button @click="resetSearchData" style="height: 30px;padding: 7px 20px;" class="resetBtn">{{$t('LanguageLib.RESET')}}</el-button>
          <el-button @click="searchOrgList" style="height: 30px;padding: 7px 20px;" type="primary" class="searchBtn">{{$t('LanguageLib.SEARCH_FOR')}}</el-button>
        </div>
      </el-drawer>
      <el-dialog style="position: absolute;" :title="$t('LanguageLib.ADD_PEOPLE')" :visible.sync="dialogAddPerson" class="addaboutPersonDialog dialogList" :before-close="closeDialog" :close-on-click-modal="false">
        <div class="operation">
          <div class="operationBtn">
            <el-button type="primary" icon="el-icon-s-custom" style="margin-left: 0;" @click="checkedAddPerson">{{$t('LanguageLib.CHECKED')}}{{selectPersonDataAdd.length}}</el-button>
          </div>
          <div class="operationSearch">
            <i @click="drawerOpenaAdd" style="cursor: pointer;" class="iconfont shaixuan" :class="{'shaixuan1' : shaixuan2}">&#xe624;</i>
            <span v-show="isSearchAdd" style="color:#666;font-size:14px;">{{$t('LanguageLib.SearchedOut')}}<span class="colorG">{{ pageTotalAddPerson }} &nbsp;</span>{{$t('LanguageLib.Results')}}</span>
            <i v-show="isSearchAdd" @click="clearSearchDataAdd" class="el-icon-close" style="margin:0 10px 0 10px;color:#666;font-size:14px;cursor: pointer;"></i>
            <el-input
              placeholder=""
              prefix-icon="el-icon-search"
              v-model="addpersonsearchText"
              @keyup.enter.native="searchAddPerson"
            >
            </el-input>
          </div>
        </div>
        <div class="domainWarp">
          <DomainTree @isCollapse-treedata="isCollapseTreedataAddPerson" @addcheck-treedata="getTreeCheckDataAddPerson" :checkDomainId="parentId" :orgData="orgData" :orgTreeData="orgTreeData" :oneNodeArr="oneNodeArr"></DomainTree>
          <div class="tableWarp" :style="styleRightAddPerson">
            <div class="tableParent">
              <el-table
                empty-text=" "
                ref="tableList"
                :data="tableDataAddPerson"
                stripe
                @selection-change="selectionChangeAddPerson"
                @sort-change='sortChangeAddPerson'
                style="width: auto;"
                v-loading="loading"
                height="100%">
                <el-table-column
                  type="selection"
                  width="45"
                  :selectable='selectInit'>
                </el-table-column>
                <el-table-column
                  prop="userName"
                  :label="$t('LanguageLib.NAME')"
                  sortable="custom"
                  min-width="100">
                  <template slot-scope="scope">
                    <el-tooltip effect="light" placement="top-start" >
                      <span v-if="!$commonfun.iswx(scope.row.userName) || !JSON.parse($commonfun.localStorage.getitem('qyuser'))" slot="content" type="userName">{{scope.row.userName}}</span>
                      <span v-if="!$commonfun.iswx(scope.row.userName) || !JSON.parse($commonfun.localStorage.getitem('qyuser'))" ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="userName">{{scope.row.userName}}</span>
                      <span v-if="$commonfun.iswx(scope.row.userName) && JSON.parse($commonfun.localStorage.getitem('qyuser'))" slot="content" type="userName">
                        <ww-open-data slot="content" type="userName" :openid="scope.row.userName.slice(3)"></ww-open-data>
                      </span>
                      <span v-if="$commonfun.iswx(scope.row.userName) && JSON.parse($commonfun.localStorage.getitem('qyuser'))" ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="userName">
                        <ww-open-data slot="content" type="userName" :openid="scope.row.userName.slice(3)"></ww-open-data>
                      </span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="userAccount"
                  :label="$t('LanguageLib.ACCOUNT')"
                  sortable="custom"
                  min-width="100">
                  <template slot-scope="scope">
                    <el-tooltip effect="light" placement="top-start">
                      <span slot="content" type="userAccount">{{scope.row.userAccount}}</span>
                      <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="userAccount">{{scope.row.userAccount}}</span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="postionName"
                  :label="$t('LanguageLib.POSITION')"
                  sortable="custom"
                  min-width="200">
                  <template slot-scope="scope">
                  <el-tooltip effect="light" placement="top-start">
                    <!-- 如果有显示职位显示显示职位 -->
                    <span v-if="scope.row.postionName" slot="content" type="postionName">{{scope.row.postionName}}</span>
                    <span v-if="scope.row.postionName" ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="postionName">{{scope.row.postionName}}</span>
                    <!-- 如果没有显示职位显示组织加角色 -->
                    <span v-if="!scope.row.postionName" slot="content" type="postionName"><span v-html="$commonfun.RenderWxName('departmentName', scope.row.defaultDomainName)"></span>&nbsp;{{scope.row.roleName}}</span>
                    <span v-if="!scope.row.postionName" ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="postionName"><span v-html="$commonfun.RenderWxName('departmentName', scope.row.defaultDomainName)"></span>&nbsp;{{scope.row.roleName}}</span>
                  </el-tooltip>
                </template>
                </el-table-column>
                <el-table-column
                  prop="workEmail"
                  :label="$t('LanguageLib.MAILBOX')"
                  sortable="custom"
                  min-width="100">
                  <template slot-scope="scope">
                  <el-tooltip effect="light" placement="top-start">
                    <span slot="content" type="workEmail">{{scope.row.workEmail}}</span>
                    <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="workEmail">{{scope.row.workEmail}}</span>
                  </el-tooltip>
                </template>
                </el-table-column>
                <el-table-column
                  prop="defaultDomainName"
                  :label="$t('LanguageLib.ORGANIZATION2')"
                  sortable="custom"
                  min-width="100">
                  <template slot-scope="scope">
                  <el-tooltip effect="light" placement="top-start">
                    <span slot="content" v-if="$commonfun.iswx(scope.row.defaultDomainName) && JSON.parse($commonfun.localStorage.getitem('qyuser'))">
                      <ww-open-data type="departmentName" :openid="scope.row.defaultDomainName.slice(3)"></ww-open-data>
                    </span>
                    <span ref="toolTipItem" v-if="$commonfun.iswx(scope.row.defaultDomainName) && JSON.parse($commonfun.localStorage.getitem('qyuser'))">
                      <ww-open-data  style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="departmentName" :openid="scope.row.defaultDomainName.slice(3)"></ww-open-data>
                    </span>
                    <span slot="content" type="departmentName" v-if="!$commonfun.iswx(scope.row.defaultDomainName) || !JSON.parse($commonfun.localStorage.getitem('qyuser'))">{{scope.row.defaultDomainName}}</span>
                    <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="departmentName" v-if="!$commonfun.iswx(scope.row.defaultDomainName) || !JSON.parse($commonfun.localStorage.getitem('qyuser'))">{{scope.row.defaultDomainName}}</span>
                  </el-tooltip>
                </template>
                </el-table-column>
              </el-table>
            </div>
            <el-pagination
              @size-change="handleSizeChangeAddPerson"
              @current-change="handleCurrentChangeAddPerson"
              :current-page="addpersoncurrentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="addpersonpageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageTotalAddPerson">
            </el-pagination>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submit()" :loading="loadingSave">{{$t('LanguageLib.DETERMINE')}}</el-button>
        </div>
        <el-drawer
          class="addPersonDrawer"
          :visible.sync="drawerAdd"
          :show-close="true"
          :modal="false"
          :wrapperClosable="false"
          size="420px"
          :with-header="false">
          <div style="overflow: hidden">
            <p style="float: left;" class="drawerTitle">{{$t('LanguageLib.Filter')}}</p>
            <el-button @click="drawerCloseAdd" style="float: right;padding: 4px 0 0 0;font-size: 18px;color: #4d4d4d;" type="text"><i class="el-icon-close"></i></el-button>
          </div>
          <div class="filterContentAboutPerson" style="padding-right: 10px;">
            <p class="drawerText">{{$t('LanguageLib.NAME')}}</p>
            <el-input
              :placeholder="$t('LanguageLib.PleaseEnter')"
              v-model="addpersonUserName"
            >
            </el-input>
            <p class="drawerText">{{$t('LanguageLib.ACCOUNT')}}</p>
            <el-input
              :placeholder="$t('LanguageLib.PleaseEnter')"
              v-model="addpersonUserAccount"
            >
            </el-input>
            <p class="drawerText">{{$t('LanguageLib.POSITION')}}</p>
            <el-input
              :placeholder="$t('LanguageLib.PleaseEnter')"
              v-model="addpersonPostionName"
            >
            </el-input>
            <p class="drawerText">{{$t('LanguageLib.MAILBOX')}}</p>
            <el-input
              :placeholder="$t('LanguageLib.PleaseEnter')"
              v-model="addpersonEmail"
            >
            </el-input>
            <p class="drawerText">{{$t('LanguageLib.ORGANIZATION2')}}</p>
            <el-input
              :placeholder="$t('LanguageLib.PleaseEnter')"
              v-model="addpersonDomainName"
            >
            </el-input>
          </div>
          <div style="float: right;margin-top: 10px;">
            <el-button @click="resetSearchDataAdd" style="height: 30px;padding: 7px 20px;" class="resetBtn">{{$t('LanguageLib.RESET')}}</el-button>
            <el-button @click="searchOrgListAdd" style="height: 30px;padding: 7px 20px;" type="primary" class="searchBtn">{{$t('LanguageLib.SEARCH_FOR')}}</el-button>
          </div>
        </el-drawer>
      </el-dialog>
      <!--已选人员-->
      <el-dialog :title="checkedPersonTitle" :visible.sync="dialogcheckedPerson" class="checkedPersonDialog dialogAdd" :before-close="closeCheckedPersonDialog" :close-on-click-modal="false" :modal="false">
          <ul>
            <li v-for="item in checkedPersonData" :key="item.userAccount">
              <img v-if="item.portrait != '' && item.portrait != null" :src="item.portrait" @error="imgError(item)"/>
              <img v-if="item.portrait == '' || item.portrait == null" src="@/assets/images/portrait.svg"/>
              <!-- <span :title="item.userName">{{item.userName}}</span> -->
              <el-tooltip effect="light" placement="top-start">
                <span slot="content" v-html="$commonfun.RenderWxName('userName', item.userName)"></span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" v-html="$commonfun.RenderWxName('userName', item.userName)"></span>
              </el-tooltip>
            </li>
          </ul>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import basicdataApi from '../../api/basicdata'
import DomainTree from '@/components/DomainTree.vue'
export default {
  name: 'AddStore',
  components: { DomainTree },
  props: ['currentPage', 'pageSize', 'parentId', 'searchText', 'sort', 'sortOrder', 'checkedStoreTypeData', 'checkedModeOperationData', 'checkedBrandData', 'orgName', 'type', 'sortNumber', 'orgTypeid', 'remark'],
  data () {
    return {
      titleType: this.$route.query.name,
      loading: true, // loading状态
      isSearch: false, // 是否为搜索状态-人员列表
      isSearchAdd: false, // 是否为搜索状态-添加人员
      orgTreeData: [], // 组织树数据
      orgData: [], // 组织树源数据
      oneNodeArr: [], // 一级组织下的数据
      drawer: false, // 抽屉框默认收起-人员列表
      drawerAdd: false, // 抽屉框默认收起-添加人员
      shaixuan1: false, // 漏斗图是否高亮-人员列表
      shaixuan2: false, // 漏斗图是否高亮-添加人员
      delDisabled: true, // 删除按钮默认禁用
      parentIdPersonList: '', // 列表请求parentId-人员列表
      parentIdAddPerson: '', // 列表请求parentId-添加人员
      styleRightPersonList: 'width: 80%;margin-left: 20%', // right默认宽度-人员列表
      styleRightAddPerson: 'width: 80%;margin-left: 20%', // right默认宽度-添加人员
      selectPersonData: [], // 选中的组织数据-id
      selectPersonDataAll: [], // 选中的组织数据-item
      selectPersonDataAdd: [], // 选中的要添加的组织数据-id
      selectPersonDataAddAll: [], // 选中的要添加的组织数据-item
      dialogAddPerson: false, // 是否显示添加人员弹框
      dialogcheckedPerson: false, // 是否显示已选人员弹框
      tableDataPerson: [], // 列表数据-人员列表
      pageTotalPerson: 0, // 数据总数-人员列表
      tableDataAddPerson: [], // 列表数据-添加人员
      pageTotalAddPerson: 0, // 数据总数-添加人员
      checkedPersonTitle: '', // 已选人员弹框标题
      prevSort: 'ascending', // 记录前一次的排序状态（elementUI默认有三种，即descending，ascending和null）
      prevProp: 'userAccount', // 记录前一次的prop值
      prevSort1: 'ascending', // 记录前一次的排序状态（elementUI默认有三种，即descending，ascending和null）
      prevProp1: 'userAccount', // 记录前一次的prop值
      getPersonList: (DomainId, pageIndex, pageSize, sort, IsAsc, UserTagId, SearchVal, UserName, UserAccount, PostionName, Email, DomainName) => {
        this.loading = true
        if (DomainId === '') {
          DomainId = null
        }
        // 请求列表接口数据
        basicdataApi.relationaUserList('post', '/tag/relationUserList', { DomainId, pageIndex, pageSize, sort, IsAsc, UserTagId, SearchVal, UserName, UserAccount, PostionName, Email, DomainName })
          .then(res => {
            this.tableDataPerson = res.data.data
            this.pageTotalPerson = res.data.total
            this.loading = false
          })
          .catch(err => {
            this.$commonfun.console.log(err)
          })
      }, // 请求数据列表的函数角色列表
      getAddPersonList: (domainId, pageIndex, pageSize, sort, IsAsc, UserTagId, SearchVal, UserName, UserAccount, PostionName, Email, DomainName) => {
        this.loading = true
        if (domainId === '') {
          domainId = null
        }
        // 请求列表接口数据
        basicdataApi.addpersonList('post', '/tag/tgruserlist', { domainId, pageIndex, pageSize, sort, IsAsc, UserTagId, SearchVal, UserName, UserAccount, PostionName, Email, DomainName })
          .then(res => {
            this.tableDataAddPerson = res.data.data
            this.pageTotalAddPerson = res.data.total
            this.loading = false
            this.$nextTick(() => {
              this.tableDataAddPerson.forEach((row, index) => {
                if (row.isCheck) {
                  this.$refs.tableList.toggleRowSelection(this.tableDataAddPerson[index])
                  this.selectPersonDataAdd = []
                  this.selectPersonDataAddAll = []
                }
              })
            })
          })
          .catch(err => {
            this.$commonfun.console.log(err)
          })
      }, // 请求数据列表的函数-添加角色
      personListcurrentPage: 1, // 默认显示第1页数据-人员列表
      personListpageSize: 20, // 默认每页显示20条数据-人员列表
      personListsort: 0, // 排序字段 0：添加时间 1：角色名称 2：组织类型 3：用户类型 -人员列表
      personListIsAsc: true, // 排序方式逆序：desc正序asc -人员列表
      personListsearchText: '', // 模糊搜索 -人员列表
      personListUserName: '', // 姓名 -人员列表
      personListUserAccount: '', // 账号 -人员列表
      personListPostionName: '', // 职位 -人员列表
      personListEmail: '', // 邮箱 -人员列表
      personListDomainName: '', // 所属组织 -人员列表
      id: this.$route.query.id, // 人员标签id
      addpersoncurrentPage: 1, // 默认显示第1页数据-添加人员
      addpersonpageSize: 20, // 默认每页显示20条数据-添加人员
      addpersonsort: 0, // 排序字段 0：添加时间 1：角色名称 2：组织类型 3：用户类型 -添加人员
      addpersonIsAsc: true, // 排序方式逆序：desc正序asc -添加人员
      addpersonsearchText: '', // 模糊搜索 -添加人员
      addpersonUserName: '', // 姓名 -添加人员
      addpersonUserAccount: '', // 账号 -添加人员
      addpersonPostionName: '', // 职位 -添加人员
      addpersonEmail: '', // 邮箱 -添加人员
      addpersonDomainName: '', // 所属组织 -添加人员
      loadingSave: false, // 保存按钮加loding
      checkedPersonData: [] // 已选择的人员数据列表
    }
  },
  created () {
    // 获取组织树列表
    basicdataApi.gettreelist('get', '/sysdomain/domainTree?showStore=true')
      .then(res => {
        this.orgData = res.data
        this.orgTreeData = this.$commonfun.toTree(res.data, 'childDomainTrees', 'id', 'parentDomainId')
        this.oneNodeArr.push(this.orgTreeData[0].id)
      })
      .catch(err => {
        this.$commonfun.console.log(err)
      })
    this.getPersonList(this.parentIdPersonList, this.personListcurrentPage, this.personListpageSize, this.personListsort, this.personListIsAsc, this.id, this.personListsearchText, this.personListUserName, this.personListUserAccount, this.personListPostionName, this.personListEmail, this.personListDomainName)
  },
  methods: {
    // 返回
    goReturn () {
      this.$router.push('/basicdata/tagmanagement?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&sort=' + this.$route.query.sort + '&isAsc=' + this.$route.query.isAsc + '&currentType=' + this.$route.query.currentType)
    },
    imgError (item) {
      item.portrait = ''
    },
    // 已添加过的人员不允许被勾选
    selectInit (row, index) {
      if (row.isCheck) {
        return false // 不可勾选
      } else {
        return true // 可勾选
      }
    },
    // 列表排序-人员列表
    sortChangePersonList (column) {
      if (column.order !== null) {
        this.prevSort = column.order
        if (column.order === 'ascending') {
          this.personListIsAsc = true
          this.prevSort = 'ascending'
        } else if (column.order === 'descending') {
          this.personListIsAsc = false
          this.prevSort = 'descending'
        }
        if (this.prevProp !== column.prop) {
          var columns = this.$refs.listPowerSupplyTab.columns.find(item => item.property === this.prevProp)
          columns.order = ''
        }
      }
      if (column.order === null) {
        column.column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        this.prevProp = column.prop
        this.prevSort = column.column.order
        this.personListIsAsc = column.column.order !== 'descending'
      }
      switch (column.prop) {
        case 'userName':
          this.personListsort = 1
          break
        case 'userAccount':
          this.personListsort = 6
          break
        case 'postionName':
          this.personListsort = 4
          break
        case 'workEmail':
          this.personListsort = 3
          break
        case 'defaultDomainName':
          this.personListsort = 5
          break
      }
      // 请求列表接口数据
      this.getPersonList(this.parentIdPersonList, this.personListcurrentPage, this.personListpageSize, this.personListsort, this.personListIsAsc, this.id, this.personListsearchText, this.personListUserName, this.personListUserAccount, this.personListPostionName, this.personListEmail, this.personListDomainName)
    },
    // 页数改变-人员列表
    handleSizeChangePersonList (val) {
      this.personListpageSize = val
      // 请求列表接口数据
      this.getPersonList(this.parentIdPersonList, this.personListcurrentPage, this.personListpageSize, this.personListsort, this.personListIsAsc, this.id, this.personListsearchText, this.personListUserName, this.personListUserAccount, this.personListPostionName, this.personListEmail, this.personListDomainName)
    },
    // 每页条数改变-人员列表
    handleCurrentChangePersonList (val) {
      this.personListcurrentPage = val
      // 请求列表接口数据
      this.getPersonList(this.parentIdPersonList, this.personListcurrentPage, this.personListpageSize, this.personListsort, this.personListIsAsc, this.id, this.personListsearchText, this.personListUserName, this.personListUserAccount, this.personListPostionName, this.personListEmail, this.personListDomainName)
    },
    // 列表模糊搜索-人员列表
    searchPersonList () {
      this.personListcurrentPage = 1
      this.getPersonList(this.parentIdPersonList, this.personListcurrentPage, this.personListpageSize, this.personListsort, this.personListIsAsc, this.id, this.personListsearchText, this.personListUserName, this.personListUserAccount, this.personListPostionName, this.personListEmail, this.personListDomainName)
    },
    // 显示隐藏组织树-人员列表
    isCollapseTreedataPersonList (data) {
      if (data === true) {
        this.styleRightPersonList = 'width: calc(100% - 25px);margin-left: 25px;transition-property: width , margin-left; transition-duration:.28s , .28s;'
      } else {
        this.styleRightPersonList = 'width: 80%;margin-left: 20%;transition-property: width , margin-left; transition-duration:.28s , .28s;'
      }
    },
    // 树组件传过来的数据-人员列表
    getTreeCheckDataPersonList (data) {
      this.parentIdPersonList = data.id
      // 请求列表接口数据
      this.personListcurrentPage = 1
      this.personListpageSize = 20
      //    this.updataRouteQuery()
      this.getPersonList(this.parentIdPersonList, this.personListcurrentPage, this.personListpageSize, this.personListsort, this.personListIsAsc, this.id, this.personListsearchText, this.personListUserName, this.personListUserAccount, this.personListPostionName, this.personListEmail, this.personListDomainName)
    },
    // 过滤点击-人员列表
    drawerOpen () {
      this.drawer = true
      this.shaixuan1 = true
    },
    // 过滤关闭-人员列表
    drawerClose () {
      this.drawer = false
      this.shaixuan1 = false
    },
    // 点击搜索-人员列表
    searchOrgList () {
      this.drawer = false
      this.isSearch = true
      this.personListcurrentPage = 1
      // this.updataRouteQuery()
      this.getPersonList(this.parentIdPersonList, this.personListcurrentPage, this.personListpageSize, this.personListsort, this.personListIsAsc, this.id, this.personListsearchText, this.personListUserName, this.personListUserAccount, this.personListPostionName, this.personListEmail, this.personListDomainName)
    },
    // 清空搜索数据-人员列表
    resetSearchData () {
      this.personListUserName = ''
      this.personListUserAccount = ''
      this.personListPostionName = ''
      this.personListEmail = ''
      this.personListDomainName = ''
    },
    // 清除搜索状态-人员列表
    clearSearchData () {
      this.shaixuan1 = false
      this.isSearch = false
      this.personListUserName = ''
      this.personListUserAccount = ''
      this.personListPostionName = ''
      this.personListEmail = ''
      this.personListDomainName = ''
      this.personListcurrentPage = 1
      //    this.updataRouteQuery()
      this.getPersonList(this.parentIdPersonList, this.personListcurrentPage, this.personListpageSize, this.personListsort, this.personListIsAsc, this.id, this.personListsearchText, this.personListUserName, this.personListUserAccount, this.personListPostionName, this.personListEmail, this.personListDomainName)
    },
    // 删除绑定人员数据
    delPerson () {
      this.$commonfun.confirm(this.$t('LanguageLib.ARE_YOU_SURE_YOU_WANT_TO_DELETE_IT1'), this.$t('LanguageLib.DELETE'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
        .then(() => {
          basicdataApi.delRelationaPerson('post', '/tag/delRelationUser', {
            UserTagId: this.$route.query.id,
            UserIds: this.selectPersonData
          })
            .then(res => {
              this.getPersonList(this.parentIdPersonList, this.personListcurrentPage, this.personListpageSize, this.personListsort, this.personListIsAsc, this.id, this.personListsearchText, this.personListUserName, this.personListUserAccount, this.personListPostionName, this.personListEmail, this.personListDomainName)
              this.$message({
                type: 'success',
                message: this.$t('LanguageLib.SUCCESSFULLY_DELETED')
              })
            })
            .catch(err => {
              this.$commonfun.console.log(err)
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('LanguageLib.DeletionCancelled')
          })
        })
    },
    // 选择要删除的人员
    selectionChange (selection) {
      this.selectPersonData = []
      this.selectPersonDataAll = []
      for (let i = 0; i < selection.length; i++) {
        this.selectPersonData.push(selection[i].id)
        this.selectPersonDataAll.push(selection[i])
      }
      if (this.selectPersonData.length === 0) {
        this.delDisabled = true
      } else {
        this.delDisabled = false
      }
    },
    // 打开已选人员-人员列表
    checkedPerson () {
      this.dialogcheckedPerson = true
      this.checkedPersonTitle = this.$t('LanguageLib.CHECKED_PERSON') + this.selectPersonDataAll.length
      this.checkedPersonData = this.selectPersonDataAll
    },
    // 关闭已选人员对话框
    closeCheckedPersonDialog () {
      this.dialogcheckedPerson = false
    },
    // 添加人员数据
    addPerson () {
      this.dialogAddPerson = true
      this.shaixuan2 = false
      this.isSearchAdd = false
      this.addpersonUserName = ''
      this.addpersonUserAccount = ''
      this.addpersonPostionName = ''
      this.addpersonEmail = ''
      this.addpersonDomainName = ''
      this.addpersoncurrentPage = 1
      this.addpersonpageSize = 20
      this.addpersonsort = 0
      this.addpersonIsAsc = true
      this.addpersonsearchText = ''
      this.selectPersonDataAdd = []
      this.selectPersonDataAddAll = []
      this.$nextTick(() => {
        this.$refs.tableList.clearSort()
      })
      this.getAddPersonList(this.parentIdAddPerson, this.addpersoncurrentPage, this.addpersonpageSize, this.addpersonsort, this.addpersonIsAsc, this.id, this.addpersonsearchText, this.addpersonUserName, this.addpersonUserAccount, this.addpersonPostionName, this.addpersonEmail, this.addpersonDomainName)
    },
    // 显示隐藏组织树-添加人员
    isCollapseTreedataAddPerson (data) {
      if (data === true) {
        this.styleRightAddPerson = 'width: calc(100% - 25px);margin-left: 25px;transition-property: width , margin-left; transition-duration:.28s , .28s;'
      } else {
        this.styleRightAddPerson = 'width: 80%;margin-left: 20%;transition-property: width , margin-left; transition-duration:.28s , .28s;'
      }
    },
    // 树组件传过来的数据-添加人员
    getTreeCheckDataAddPerson (data) {
      this.parentIdAddPerson = data.id
      console.log(this.parentIdAddPerson)
      // 请求列表接口数据
      this.addpersoncurrentPage = 1
      this.addpersonpageSize = 20
      //    this.updataRouteQuery()
      this.getAddPersonList(this.parentIdAddPerson, this.addpersoncurrentPage, this.addpersonpageSize, this.addpersonsort, this.addpersonIsAsc, this.id, this.addpersonsearchText, this.addpersonUserName, this.addpersonUserAccount, this.addpersonPostionName, this.addpersonEmail, this.addpersonDomainName)
    },
    // 过滤点击-添加人员
    drawerOpenaAdd () {
      this.drawerAdd = true
      this.shaixuan2 = true
    },
    // 过滤关闭-添加人员
    drawerCloseAdd () {
      this.drawerAdd = false
      this.shaixuan2 = false
    },
    // 点击搜索-添加人员
    searchOrgListAdd () {
      this.drawerAdd = false
      this.isSearchAdd = true
      this.addpersoncurrentPage = 1
      // this.updataRouteQuery()
      this.getAddPersonList(this.parentIdAddPerson, this.addpersoncurrentPage, this.addpersonpageSize, this.addpersonsort, this.addpersonIsAsc, this.id, this.addpersonsearchText, this.addpersonUserName, this.addpersonUserAccount, this.addpersonPostionName, this.addpersonEmail, this.addpersonDomainName)
    },
    // 清空搜索数据-添加人员
    resetSearchDataAdd () {
      this.addpersonUserName = ''
      this.addpersonUserAccount = ''
      this.addpersonPostionName = ''
      this.addpersonEmail = ''
      this.addpersonDomainName = ''
    },
    // 清除搜索状态-添加人员
    clearSearchDataAdd () {
      this.drawerAdd = false
      this.shaixuan2 = false
      this.isSearchAdd = false
      this.addpersonUserName = ''
      this.addpersonUserAccount = ''
      this.addpersonPostionName = ''
      this.addpersonEmail = ''
      this.addpersonDomainName = ''
      this.addpersoncurrentPage = 1
      //    this.updataRouteQuery()
      this.getAddPersonList(this.parentIdAddPerson, this.addpersoncurrentPage, this.addpersonpageSize, this.addpersonsort, this.addpersonIsAsc, this.id, this.addpersonsearchText, this.addpersonUserName, this.addpersonUserAccount, this.addpersonPostionName, this.addpersonEmail, this.addpersonDomainName)
    },
    // 列表排序 -添加人员
    sortChangeAddPerson (column) {
      if (column.order !== null) {
        this.prevSort1 = column.order
        if (column.order === 'ascending') {
          this.addpersonIsAsc = true
          this.prevSort1 = 'ascending'
        } else if (column.order === 'descending') {
          this.addpersonIsAsc = false
          this.prevSort1 = 'descending'
        }
        if (this.prevProp1 !== column.prop) {
          var columns = this.$refs.tableList.columns.find(item => item.property === this.prevProp1)
          columns.order = ''
        }
      }
      if (column.order === null) {
        column.column.order = this.prevSort1 === 'descending' ? 'ascending' : 'descending'
        column.order = this.prevSort1 === 'descending' ? 'ascending' : 'descending'
        this.prevProp1 = column.prop
        this.prevSort1 = column.column.order
        this.addpersonIsAsc = column.column.order !== 'descending'
      }
      switch (column.prop) {
        case 'userName':
          this.addpersonsort = 1
          break
        case 'userAccount':
          this.addpersonsort = 6
          break
        case 'postionName':
          this.addpersonsort = 4
          break
        case 'workEmail':
          this.addpersonsort = 3
          break
        case 'defaultDomainName':
          this.addpersonsort = 5
          break
      }
      // 请求列表接口数据
      this.getAddPersonList(this.parentIdAddPerson, this.addpersoncurrentPage, this.addpersonpageSize, this.addpersonsort, this.addpersonIsAsc, this.id, this.addpersonsearchText, this.addpersonUserName, this.addpersonUserAccount, this.addpersonPostionName, this.addpersonEmail, this.addpersonDomainName)
    },
    // 页数改变 -添加人员
    handleSizeChangeAddPerson (val) {
      this.addpersonpageSize = val
      // 请求列表接口数据
      this.getAddPersonList(this.parentIdAddPerson, this.addpersoncurrentPage, this.addpersonpageSize, this.addpersonsort, this.addpersonIsAsc, this.id, this.addpersonsearchText, this.addpersonUserName, this.addpersonUserAccount, this.addpersonPostionName, this.addpersonEmail, this.addpersonDomainName)
    },
    // 每页条数改变 -添加人员
    handleCurrentChangeAddPerson (val) {
      this.addpersoncurrentPage = val
      // 请求列表接口数据
      this.getAddPersonList(this.parentIdAddPerson, this.addpersoncurrentPage, this.addpersonpageSize, this.addpersonsort, this.addpersonIsAsc, this.id, this.addpersonsearchText, this.addpersonUserName, this.addpersonUserAccount, this.addpersonPostionName, this.addpersonEmail, this.addpersonDomainName)
    },
    // 列表模糊搜索 -添加人员
    searchAddPerson () {
      this.addpersoncurrentPage = 1
      this.getAddPersonList(this.parentIdAddPerson, this.addpersoncurrentPage, this.addpersonpageSize, this.addpersonsort, this.addpersonIsAsc, this.id, this.addpersonsearchText, this.addpersonUserName, this.addpersonUserAccount, this.addpersonPostionName, this.addpersonEmail, this.addpersonDomainName)
    },
    // 选择要添加的人员
    selectionChangeAddPerson (selection) {
      this.selectPersonDataAdd = []
      this.selectPersonDataAddAll = []
      for (let i = 0; i < selection.length; i++) {
        if (!selection[i].isCheck) {
          this.selectPersonDataAdd.push(selection[i].userId)
          this.selectPersonDataAddAll.push(selection[i])
        }
      }
    },
    // 已选人员 -添加人员
    checkedAddPerson () {
      console.log(this.selectPersonDataAddAll)
      this.dialogcheckedPerson = true
      this.checkedPersonTitle = this.$t('LanguageLib.CHECKED_PERSON') + this.selectPersonDataAddAll.length
      this.checkedPersonData = this.selectPersonDataAddAll
    },
    // 关闭对话框  清除校验
    closeDialog () {
      this.drawerAdd = false
      this.dialogAddPerson = false
    },
    // 添加人员
    submit () {
      if (this.selectPersonDataAdd.length === 0) {
        this.dialogAddPerson = false
      } else {
        this.loadingSave = true
        basicdataApi.CreateRelationaUser('post', '/tag/addrelationUser', {
          UserTagId: this.$route.query.id,
          UserIds: this.selectPersonDataAdd
        })
          .then(res => {
            this.$message({
              type: 'success',
              message: this.$t('LanguageLib.ADDED_SUCCESSFULLY1')
            })
            this.dialogAddPerson = false
            this.getPersonList(this.parentIdPersonList, this.personListcurrentPage, this.personListpageSize, this.personListsort, this.personListIsAsc, this.id, this.personListsearchText, this.personListUserName, this.personListUserAccount, this.personListPostionName, this.personListEmail, this.personListDomainName)
            this.loadingSave = false
          })
          .catch(err => {
            this.loadingSave = false
            this.$commonfun.console.log(err)
          })
      }
    }
  }
}
</script>

<style lang="scss">
  .bindRole {
    .TeInput input {
      border-right: 0px;
      border-radius: 4px 0 0 4px;
    }
    .return {
      padding-left: 25px;
      position: relative;
      height: 50px;
      background: rgba(255, 255, 255, 1);
      line-height: 50px;
      border-bottom: 1px solid #F2F2F2;
      .el-icon-back {
        margin-right: 15px;
        cursor: pointer;
      }
      .border {
        position: absolute;
        height: 37px;
        border-left: 1px solid #f1f1f1;
        display: inline-block;
        top: 5px;
      }
      .title {
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        margin-left: 15px;
      }
    }
    .content::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    .content::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      background: #E1E1E1;
    }
    .content::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      border-radius: 5px;
      background: #fff;
    }
    // 抽屉组件样式修改
    .el-drawer.rtl{
      outline: none;
    }
    .el-drawer__wrapper{
      top: 233px;
      bottom: 35px;
      /*right: 20px;*/
    }
    .addPersonDrawer{
      top: 110px;
      bottom: 0;
      right: 0;
      position: absolute;
    }
    section.el-drawer__body{
      padding: 20px;
      .el-input{
        margin-bottom: 15px;
      }
    }
    .el-drawer__container{
      outline: none;
    }
    .drawerTitle{
      height:25px;
      font-size:18px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(77,77,77,1);
      line-height:25px;
      margin-bottom: 20px;
    }
    .drawerText{
      height:16px;
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(77,77,77,1);
      line-height:16px;
      margin-bottom: 5px;
    }
    .content {
      background: rgba(255, 255, 255, 1);
      width: 100%;
      height: calc( 100% - 66px);
      overflow-y: auto;
      padding: 0 100px 20px 100px;
      padding-top: 15px;
      box-sizing: border-box;
      .operation{
        background: #fff;
        padding: 0;
        overflow: hidden;
        .operationBtn{
          width: auto;
          display: inline-block;
          float:left;
          position: relative;
          .el-button{
            height: 30px;
            padding: 7px 20px;
          }
        }
        .operationSearch{
          float:right;
          position: relative;
          .shaixuan{
            color: #999999;
            height: 15px;
            width: 15px;
            position: relative;
            top: 2px;
            margin-left: 10px;
            margin-right: 10px;
            font-weight: 600;
          }
          .shaixuan1{
            color: #3BC6B9;
          }
          .el-input{
            width: 160px;
            .el-input__inner{
              height: 30px;
              line-height: 30px;
              border-radius: 20px;
            }
          }
          .el-icon-search{
            line-height: 30px;
          }
        }
      }
      .tableWarp{
        border: 1px solid #E1E1E1;
        height: 100%;
        width: 80%;
        margin-left: 20%;
      }
      .domainWarp{
        height: calc(100% - 47px);
        .left{
          background: #fff;
          width: 20%;
          float:left;
          height: calc(100% - 0px);
          border-right: 1px solid #E1E1E1;
          border-bottom: 1px solid #E1E1E1;
          .treeBox{
            height: calc( 100% - 51px );
            overflow: auto;
            width: 100%;
          }
          .fifter{
            padding: 10px 0 10px 6%;
            line-height: 30px;
          .el-input{
              width: 60%;
            }
            .el-button--text{
              margin-left: 2.5%;
              padding: 2% 0;
              width: 20%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
      // 对于树组件配置特有的css
      .el-tree-node>.el-tree-node__children{
        overflow: unset;
      }
      .el-tree-node__content{
        height: 48px;
      }
      .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
        background-color: #F6F6F6;
      }
      // .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content>span:last-child{
      //   color: #3BC6B9 !important;
      // }
      // .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content>ww-open-data{
      //   color: #3BC6B9 !important;
      // }
      .tableParent{
        height: calc( 100% - 48px );
      }
      .el-pagination{
        padding: 8px 15px 5px;
        height: 35px;
        background: #fff;
      }
      .el-button--primary{
        background-color:#3BC6B9;
        color:#fff;
        border:none;
        margin-left: 10px;
      }
      .el-button--primary:hover{
        background-color:#3BC6B9;
        color:#fff;
        border:none;
      }
      /*.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
        background-color: #3BC6B9 !important;
        border-color: #3BC6B9 !important;
      }*/
      // 更改表格的滚动条样式
      .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar,
      .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
          width: 10px;
          height: 10px;
      }
      .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb,
      .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
        border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
        background: #E1E1E1;
      }
      .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-track,
      .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
        border-radius: 5px;
        background: #fff;
      }
      .colorG{
        height:20px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(59,198,185,1);
        line-height:20px;
      }
      .el-table .descending .sort-caret.descending{
        border-top-color: #3BC6B9;
      }
      .el-table .ascending .sort-caret.ascending{
        border-bottom-color: #3BC6B9;
      }
      .el-pager li.active{
        color: #3BC6B9;
      }
      .el-table__fixed-body-wrapper .el-table__body{
          padding-bottom: 10px;
      }
      .filterContentAboutPerson{
        height: calc(100% - 190px);
        overflow: hidden;
        overflow-y: auto;
      }
      .filterContentAboutPerson::-webkit-scrollbar{
          width: 10px;
          height: 10px;
      }
      .filterContentAboutPerson::-webkit-scrollbar-thumb {
        border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
        background: #E1E1E1;
      }
      .filterContentAboutPerson::-webkit-scrollbar-track {
        border-radius: 5px;
        background: #fff;
      }
      .el-table-column--selection{
        text-align: center !important;
      }
      .el-tooltip__popper.is-dark{
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        border: 1px solid #E4E7ED !important;
        background-color: #fff;
        color: #000;
        .popper__arrow{
          border-top-color: #E4E7ED;
        }
        .popper__arrow::after{
          border-top-color: #fff;
        }
      }
      .el-table__fixed-right{
        height: 100% !important;
      }
    }
     /*修改按钮样式*/
    .el-button--primary {
      background-color: #3BC6B9;
      border-color: #3BC6B9;
      height: 30px;
      padding: 7px 20px;
      margin-bottom: 15px;
    }
    .colorRed {
      color: red;
    }
    .el-table__header{
      width: calc(100% + 17px) !important;
    }
    .el-table__body{
      width: calc(100% + 7px) !important;
    }
  }
  .uploadParent{
    .el-button--primary{
      margin-bottom: 0;
    }
    .el-upload__tip{
      margin-top: 10px;
    }
  }
.checkedPersonDialog{
  .el-dialog{
    height: calc(100% - 170px);
    width: 420px !important;
    .el-dialog__header{
      padding-top: 20px;
      .el-dialog__headerbtn{
        top: 24px;
      }
    }
    .el-dialog__body{
      padding-top: 10px;
      height: calc(100% - 84px);
      overflow-y: auto;
      ul{
        list-style: none;
        overflow: hidden;
        li{
          float: left;
          width: 20%;
          text-align: center;
          margin-bottom: 20px;
          img{
            width: 80%;
            border-radius: 50%;
            /*border: 1px solid #E1E1E1;*/
          }
          span{
            display: block;
            width: calc(100% - 20px);
            padding: 0 10px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
    .el-dialog__body::-webkit-scrollbar{
        width: 10px;
        height: 10px;
    }
    .el-dialog__body::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
      background: #E1E1E1;
    }
    .el-dialog__body::-webkit-scrollbar-track {
      border-radius: 5px;
      background: #fff;
    }
  }
}
.addaboutPersonDialog{
  .el-dialog{
    height: calc(100% - 170px);
    width: 1000px !important;
    .el-dialog__body{
      padding-top: 0;
      padding-bottom: 0;
      height: calc(100% - 130px);
      .operationSearch{
        overflow: hidden;
        margin-bottom: 10px;
        line-height: 30px;
        .shaixuan{
          color: #999999;
          height: 15px;
          width: 15px;
          position: relative;
          top: 2px;
          margin-left: 10px;
          margin-right: 10px;
          font-weight: 600;
        }
        .shaixuan1{
          color: #3BC6B9;
        }
        .el-input{
          width: 160px;
          float: right;
          .el-input__inner{
            height: 30px;
            line-height: 30px;
            border-radius: 20px;
          }
        }
        .el-icon-search{
          line-height: 30px;
        }
      }
      .tableParent{
        height: calc(100% - 48px);
      }
    }
    .el-dialog__footer{
      padding: 25px 20px 20px;
    }
  }
  .el-pagination{
    padding: 8px 15px 5px;
    height: 35px;
    background: #fff;
  }
}
</style>
